import { Boundaries } from "@planzone/core";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State } from "./types";

function handleSuccess(
  state: State,
  {
    project,
    discussions,
    page,
    size,
  }: Boundaries["retrieveDiscussions"]["success"],
): State {
  return state.map((result) => {
    if (result.project.uuid !== project.uuid) return result;

    const previousDiscussions =
      page === 0
        ? []
        : result.discussions.filter(
            (existing) =>
              !discussions.some((incoming) => incoming.uuid === existing.uuid),
          );

    return {
      ...result,
      discussions: [...previousDiscussions, ...discussions],
      page: page + 1,
      canLoadMore: discussions.length >= size,
      request: setRequestStateToSuccess(),
    };
  });
}

export { handleSuccess };
